import React, { useState } from "react";
import { Table } from "react-bootstrap";
import { empty, kopecks2rubStr } from "../../../common/functions";
import { ITransaction, ITransactionsByMonth } from "../../payments/logics/types";
import { TransactionTypeCharge } from "../../payments/logics/getTransactions";
import { AccountTransactionsItemTableData } from "./AccountTransactionsItemTableData";
import { AccountTransactionsItemTitle } from "./AccountTransactionsItemTitle";

import "../styles/AccountTransactionsItem.css";
import { $SiteColors } from "../../../common/config/company-atts";

interface IAccountTransactionsItem {
  transactionByMonth: ITransactionsByMonth,
  accountId: number,
  monthTransactions: ITransaction[],
  hideInfo: boolean
  i: number,
}

export const AccountTransactionsItem = ({accountId, transactionByMonth, monthTransactions, hideInfo, i}: IAccountTransactionsItem) => {
  const [hidePaymentsTable, setHidePaymentsTable] = useState(true);

  function showPaymentsTableClicked() {
    setHidePaymentsTable(!hidePaymentsTable)
  }

  if(monthTransactions.length == 0) return <></>

  return (
    <li style={{marginTop: "5px", marginBottom: "5px"}}>
      <AccountTransactionsItemTitle i={i} transactionByMonth={transactionByMonth} showTableCliked={showPaymentsTableClicked} hideTable={hidePaymentsTable} hideInfo={hideInfo} />
      <hr hidden={hidePaymentsTable} style={{border: "1px solid rgba(0, 0, 0, 0.25)"}} />
      <div hidden={hidePaymentsTable} style={{marginLeft: "50px", maxWidth: "530px"}} >
        <Table responsive="sm" className="table-borderless" size="sm">
          <tbody>
            {monthTransactions.map((t, i) => (
              <tr key={i}>
                <td className="a_ati_tr"><AccountTransactionsItemTableData type={t.type} date={t.date} /></td>
                <td>
                  <span style={{fontWeight: "bold", fontSize: "16px", lineHeight: "19px", color: t.type == TransactionTypeCharge ? $SiteColors.getState().chargeTextColor : "#000000", marginBottom: "15px"}}>
                    {kopecks2rubStr(parseInt(empty(t.amount) ? "0" : t.amount))}
                  </span>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
    </li>
  );
};